import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const ContextCollectionLazy = loadable(
    () => import(/* webpackChunkName: "Collections" */ './ContextCollectionSuspense')
);

export const ContextCollectionAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <ContextCollectionLazy />
    </DelayedSuspense>
);
